export default function() {
	const body = document.getElementsByTagName('body')[0];
	const button = document.querySelector('.filter__deploy');
	button.onclick = () => {
		if ( body.classList.contains('is-active-mobile-filter') ) {
			body.classList.remove('is-active-mobile-filter');
			button.innerHTML = 'Filter';
		} else {
			body.classList.add('is-active-mobile-filter');
			button.innerHTML = 'Done';
		}
	}
}
